<!-- <div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">cliente</span>
  <input id="Email" [(ngModel)]="direccion.id_cliente" type="text" class="form-control"
    aria-label="Email" aria-describedby="inputGroup-sizing-default" disabled>
</div> -->

<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Alias</span>
  <input id="alias" [(ngModel)]="direccion.nombre" type="text" class="form-control"
    aria-label="alias" aria-describedby="inputGroup-sizing-default">
</div>

<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Provincia</span>
  <input id="provincia" [(ngModel)]="direccion.provincia" type="text" class="form-control"
    aria-label="provincia" aria-describedby="inputGroup-sizing-default">
</div>

<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Localidad</span>
  <input id="localidad" [(ngModel)]="direccion.localidad" type="text" class="form-control"
    aria-label="localidad" aria-describedby="inputGroup-sizing-default">
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Direccion</span>
  <input id="direccion" [(ngModel)]="direccion.direccion" type="text" class="form-control"
    aria-label="direccion" aria-describedby="inputGroup-sizing-default">
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">CP</span>
  <input id="cp" [(ngModel)]="direccion.cp" type="text" class="form-control"
    aria-label="cp" aria-describedby="inputGroup-sizing-default">
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Piso/Departamento</span>
  <input id="piso_dpto" [(ngModel)]="direccion.piso_dpto" type="text" class="form-control"
    aria-label="piso_dpto" aria-describedby="inputGroup-sizing-default">
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Telefono</span>
  <input id="telefono" [(ngModel)]="direccion.telefono" type="text" class="form-control"
    aria-label="telefono" aria-describedby="inputGroup-sizing-default">
</div>
<div class="col-3">
  <button type="button" class="btn btn-primary" (click)="enviar()" >Guardar</button>
</div>
<!-- <div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Localidad</span>
  <input id="localidad" [(ngModel)]="direccion.localidad" type="text" class="form-control"
    aria-label="localidad" aria-describedby="inputGroup-sizing-default">
</div> -->
